import { useEffect, useState } from 'react';
import { useDispatch, useTrackedState } from '../../config/store';

function CandidateResumePDF(interview) {
  const state = useTrackedState();
  const dispatch = useDispatch();
  const [isFetchingPDF, setIsFetchingPDF] = useState(false);

  const fetchCandidateResume = () => {
    if (state.resumePDF?.url && interview?.interviewData.Candidate_Name.id === state.resumePDF?.id) {
      window.open(window.URL.createObjectURL(state.resumePDF.url));
      window.URL.revokeObjectURL(state.resumePDF.url);
    } else {
      setIsFetchingPDF(true);
      dispatch({
        type: 'GET_RESUME_PDF',
        candidateId: interview.interviewData.Candidate_Name.id,
        token: state.user.token,
      });
    }
  };
  useEffect(() => {
    if (state.error || (state.resumePDF?.url && interview?.interviewData.Candidate_Name.id === state.resumePDF?.id)) {
      setIsFetchingPDF(false);
    }
  }, [state.resumePDF, state.error, interview, isFetchingPDF]);

  const openCandidateResume = () => {
    if (state.resumePDF?.url) {
      const pdfUrl = window.URL.createObjectURL(state.resumePDF.url);
      window.open(pdfUrl, '_blank');
      window.URL.revokeObjectURL(state.resumePDF.url);
    }
  };

  return {
    fetchCandidateResume,
    openCandidateResume,
    hasResumePDF: !!state.resumePDF?.url,
    isFetchingPDF,
  };
}

export default CandidateResumePDF;
